import {h, Fragment} from "preact"
export default function SubmitButton({ className, text }) {
    const handleClick = () => {
        const input = document.querySelector('#search-input');
        if (!input) return;

        ['keydown', 'keypress', 'keyup'].forEach(eventType => {
            const event = new KeyboardEvent(eventType, {
                key: 'Enter',
                code: 'Enter',
                keyCode: 13,
                which: 13,
                bubbles: true,
            });
            input.dispatchEvent(event);
        });
    };

    return (
        <div className={`ns-autocomplete-submit ns-d-flex ns-justify-content-end ns-pt-0 ns-pl-4 ns-pr-4 ns-pb-3 ns-pb-md-5 ${className}`}>
            <button type="button" className="btn btn--small nosto-view-all-btn" onClick={handleClick}>
                {text}
            </button>
        </div>
    );
}